"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Header = exports.CardLink = exports.WrapperLink = exports.Wrapper = exports.Content = void 0;
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("../../../theme");
var Link_1 = __importDefault(require("../../navigation/Link"));
var PADDING = {
    '1': {
        small: 24,
        medium: 32,
        large: 32,
    },
    '2': {
        small: 16,
        medium: 24,
        large: 24,
    },
};
exports.Content = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding: ", "px;\n\n  @media ", " {\n    padding: ", "px;\n  }\n\n  @media ", " {\n    padding: ", "px;\n  }\n"], ["\n  padding: ", "px;\n\n  @media ", " {\n    padding: ", "px;\n  }\n\n  @media ", " {\n    padding: ", "px;\n  }\n"])), function (_a) {
    var $level = _a.$level;
    return PADDING[$level].small;
}, theme_1.theme.breakpoints.medium, function (_a) {
    var $level = _a.$level;
    return PADDING[$level].medium;
}, theme_1.theme.breakpoints.large, function (_a) {
    var $level = _a.$level;
    return PADDING[$level].large;
});
var JUSTIFY = {
    stretch: 'stretch',
    top: 'flex-start',
    center: 'center',
};
var styles = (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  ", "\n  border-radius: 10px;\n  background-color: ", ";\n  overflow: hidden;\n  justify-content: ", ";\n  border: ", ";\n\n  ", " {\n    flex-grow: ", ";\n  }\n"], ["\n  display: flex;\n  flex-direction: column;\n  ", "\n  border-radius: 10px;\n  background-color: ", ";\n  overflow: hidden;\n  justify-content: ", ";\n  border: ", ";\n\n  ", " {\n    flex-grow: ", ";\n  }\n"])), function (_a) {
    var $elevated = _a.$elevated;
    return $elevated && theme_1.theme.elevation.ELEVATION_50;
}, theme_1.theme.colors.WHITE, function (_a) {
    var $align = _a.$align;
    return JUSTIFY[$align];
}, function (_a) {
    var $border = _a.$border;
    return ($border ? "1px solid ".concat(theme_1.theme.colors.GREY_50) : '');
}, exports.Content, function (_a) {
    var $align = _a.$align;
    return ($align === 'stretch' ? 1 : '');
});
exports.Wrapper = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), styles);
exports.WrapperLink = styled_components_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  ", "\n\n  position: relative;\n\n  ", " {\n    transition: transform 0.1s ease, box-shadow 0.1s ease;\n    will-change: transform;\n\n    &:hover {\n      transform: translateY(-7px);\n      ", "\n\n      color: ", "\n    }\n  }\n"], ["\n  ", "\n\n  position: relative;\n\n  ", " {\n    transition: transform 0.1s ease, box-shadow 0.1s ease;\n    will-change: transform;\n\n    &:hover {\n      transform: translateY(-7px);\n      ", "\n\n      color: ", "\n    }\n  }\n"])), styles, theme_1.theme.utils.canHover, function (_a) {
    var $elevated = _a.$elevated;
    return $elevated && theme_1.theme.elevation.ELEVATION_70;
}, theme_1.theme.colors['BLUE_50']);
exports.CardLink = (0, styled_components_1.default)(Link_1.default)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  border-radius: 10px;\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  outline-offset: -1px;\n"], ["\n  border-radius: 10px;\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  outline-offset: -1px;\n"])));
exports.Header = styled_components_1.default.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  flex-shrink: 0;\n"], ["\n  flex-shrink: 0;\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
